import {FC, useState, useEffect, Fragment} from 'react'

import {Link, useNavigate} from 'react-router-dom'

import './style.css'
import AlertModal from './AlertModal'

import Api from '../../../thesis-and-dissertations/helpers/api'

import './style.css'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {PageTitle} from '_metronic/layout/core'
import NotRegisteredPage from './NotRegisteredPage'
import Register from '../Register'
import RegisteredPage from './RegisteredPage'
import {toast} from 'react-toastify'
const api = new Api()

const MyPanaPage: FC = () => {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [dataPana, setDataPana] = useState<any>({})
  const [currentPage, setCurrentPage] = useState('notRegistered')

  useEffect(() => {
    getPana()
  }, [])

  const getPana = () => {
    setLoading(true)
    api
      .getRegisterPana()
      .then((response: any) => {
        setLoading(false)
        const {data} = response.data
        setDataPana(data)
        pageCondition(data)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response

        handleApiError(error, navigate)
        toast.error(data?.meta?.message)
      })
  }

  const pageCondition = (data: any) => {
    if (typeof data?.step == undefined) {
      setCurrentPage('NotRegisteredPage')
      return
    }

    if (data?.is_selesai == 1) {
      setCurrentPage('registered')
      return
    }

    if (data?.step >= 0) {
      setCurrentPage('register')
    }
  }

  const registerPana = (data: object) => {
    setLoading(true)
    api
      .registerPana(data)
      .then((response: any) => {
        setLoading(false)
        const {data} = response.data
        setCurrentPage('register')
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response

        handleApiError(error)
        toast.error(data?.meta?.message)
      })
  }

  const handleToPage = (page: string) => {
    if (page == 'notRegistered' && dataPana?.is_selesai == 1) {
      setCurrentPage('registered')
      return
    }

    if (page == 'register') {
      registerPana({step: 0})
      return
    }

    setCurrentPage(page)
  }

  const page = (page: string) => {
    switch (page) {
      case 'notRegistered':
        return <NotRegisteredPage handleToPage={handleToPage} />
      case 'register':
        return <Register handleToPage={handleToPage} />
      case 'registered':
        return <RegisteredPage dataPana={dataPana} handleToPage={handleToPage} />
    }
  }

  return <>{page(currentPage)}</>
}

const MyPana: FC = () => {
  return <MyPanaPage />
}

export default MyPana
